import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";

const getCountryList = () => {
  return responseFormatter.rc(
    http.rc.get(`/dictionary/country?perPage=1000`, {
      setAuthHeader: true,
    })
  );
};
// const parsePhoneNumber = data => {
//   return rcApiResponseFormatter(rcApi.post('/number-parser/parse', data));
// };
const parsePhoneNumber = (data) => {
  return responseFormatter.rc(
    http.rc.post("/number-parser/parse", data, {
      setAuthHeader: true,
    })
  );
};
const bulkEdit = (ids, data) => {
  return responseFormatter(
    http.patch(`/notifications/bulk/edit?ids=${ids}`, data, {
      setAuthHeader: true,
    })
  );
};

// const post = (id) => {
//   return responseFormatter(
//     http.post(
//       `/account`,
//       { rc_account_id: id },
//       {
//         setAuthHeader: true,
//       }
//     )
//   );
// };

const get = (query = "", id = "") => {
  return responseFormatter(
    http.get(`/notifications${query == null ? id : query}`, {
      setAuthHeader: true,
    })
  );
};

const exportNotification = (query = "") => {
	debugger;
  return responseFormatter(
    http.get(`/notifications/export${query}`, {
      setAuthHeader: true,
    })
  );
};

const deleteNotification = (query = "") => {
  return responseFormatter(
    http.delete(`/notifications${query}`, {
      setAuthHeader: true,
    })
  );
};

const duplicateNotification = (query = "") => {
  return responseFormatter(
    http.post(
      `/notifications/duplicate${query}`,
      {},
      {
        setAuthHeader: true,
      }
    )
  );
};

const toggle = (id = "", isChecked = "") => {
  return responseFormatter(
    http.patch(
      `/notifications/toggle${id}`,
      { enabled: isChecked },
      {
        setAuthHeader: true,
      }
    )
  );
};

const create = (payload = "") => {
  return responseFormatter(
    http.post(`/notifications`, payload, {
      setAuthHeader: true,
    })
  );
};

const editNotification = (id = "", payload = {}) => {
  return responseFormatter(
    http.patch(`/notifications/${id}`, payload, {
      setAuthHeader: true,
    })
  );
};

// const updateNotification = (query = "", id = "") => {
//   return responseFormatter(
//     http.put(`/notifications/${id}`, {
//       setAuthHeader: true,
//     })
//   );
// };

const updatePreferences = (preference) => {
  return responseFormatter(
    http.post(`/setuserpreferences`, preference, {
      setAuthHeader: true,
    })
  );
};

const getUserDetails = () => {
  // return responseFormatter(
  //   http.get(`/user/me`, {
  //     setAuthHeader: true,
  //   })
  // );
};

const getAllUsers = (accountId = "~") => {
  return responseFormatter.rc(
    http.rc.get(`/account/${accountId}/extension?type=User&perPage=1000`, {
      setAuthHeader: true,
    })
  );
};

const getAllTeams = (accountId = "~") => {
  return responseFormatter.rc(
    http.rc.get(`/glip/teams?recordCount=250`, {
      setAuthHeader: true,
    })
  );
};

const getTimezoneList = async () => {
  return responseFormatter.rc(
    http.rc.get(`/dictionary/timezone?perPage=1000`, {
      setAuthHeader: true,
    })
  );
};

const getExtensions = async (accountId = "~") => {
  return responseFormatter.rc(
    http.rc.get(`/account/${accountId}/extension?perPage=1000`, {
      setAuthHeader: true,
    })
  );
};

const acknowledgeRegulation = () => {
  return responseFormatter(
    http.patch(`/setregulationsacknowledgement`, {}, {
      setAuthHeader: true,
    })
  );
};

const Service = {
  getCountryList,
  get,
  exportNotification,
  deleteNotification,
  duplicateNotification,
  toggle,
  create,
  // post,
  editNotification,
  getUserDetails,
  parsePhoneNumber,
  bulkEdit,
  // getWhiteList,

  // updateNotification
  updatePreferences,
  getAllUsers,
  getAllTeams,
  getTimezoneList,
  getExtensions,
  acknowledgeRegulation
};

export default Service;
